import { Injectable } from '@angular/core';
import { TipoDocumentacao } from '@tivic-team/manager-ts/dist/grl/entities/tipo-documentacao.entity';
import { TipoDocumentacaoController } from 'app/controllers/grl/tipo-documentacao.controller';
import { ApiService } from '../api-service.interface';
import { LoaderService } from '../loader.service';
import { TipoDocumentacaoSearch } from './tipo-documentacao.search';


@Injectable({
  providedIn: 'root'
})
export class TipoDocumentacaoService implements ApiService<TipoDocumentacao>{

  constructor(
    private _tipoDocumentacaoController: TipoDocumentacaoController,
    private _loaderService: LoaderService
  ) { }

  find(search?: TipoDocumentacaoSearch): Promise<TipoDocumentacao[]> {
    this._loaderService.show();
    return this._tipoDocumentacaoController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }
    
  get(id: number): Promise<TipoDocumentacao> {
    this._loaderService.show();
    return this._tipoDocumentacaoController.get(id).finally(() => this._loaderService.hide());
  }

  async getAll(isLoading:boolean=true):Promise<Array<TipoDocumentacao>>{
    try{
      if(isLoading) this._loaderService.show();
      return await this._tipoDocumentacaoController.getAll().finally(() => {if (isLoading) this._loaderService.hide()});
    } catch(error){
      return [];
    }
  }

  save(entity: TipoDocumentacao): Promise<TipoDocumentacao> {
    if(!entity.cdTipoDocumentacao)
      return this.create(entity);
    return this.update(entity);
  }

  create(entity: TipoDocumentacao): Promise<TipoDocumentacao> {
    this._loaderService.show();
    return this._tipoDocumentacaoController.create(entity).finally(() => this._loaderService.hide());
  }

  update(entity: TipoDocumentacao): Promise<TipoDocumentacao> {
    this._loaderService.show();
    return this._tipoDocumentacaoController.update(entity).finally(() => this._loaderService.hide());
  }
}
